import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { trackInternalPageView, initSession } from "../lib/internal-analytics";

export const useAnalytics = () => {
  const [location] = useLocation();
  const prevLocationRef = useRef<string>(location);
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      initSession();
      initialized.current = true;
    }
  }, []);

  useEffect(() => {
    if (location !== prevLocationRef.current) {
      trackInternalPageView(location);
      prevLocationRef.current = location;
    }
  }, [location]);
};
